import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "./drug_detail.module.css";
import LoadingButton from "@mui/lab/LoadingButton";
import { TextField } from "@mui/material";
import moment from "moment-timezone";
import Autocomplete from "@mui/material/Autocomplete";
import { put, get, post } from "util/requests";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Checkbox } from "@mui/material";
import { useLocation } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import router from "routes";

const Form = (props) => {
  const { setEdit, drug } = props;
  const { data = {} } = drug;
  return (
    <div>
      <div className={styles.profile_row}>
        <div className={styles.profile_row_title}>Name:</div>
        <div>{drug.name}</div>
      </div>
      <div className={styles.profile_row}>
        <div className={styles.profile_row_title}>Expiry Lead Time (days):</div>
        <div>{data.expiry_buffer_days}</div>
      </div>

      <LoadingButton
        variant="contained"
        loading={false}
        onClick={() => {
          setEdit(true);
        }}
      >
        EDIT
      </LoadingButton>
    </div>
  );
};

const EditForm = (props) => {
  const { drug, setEdit, setSite, regionList, newSite, study_id, studyConfig } = props;
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [localDrug, setLocalDrug] = useState({
    ...drug,
  });
  const [crfVersions, setCrfVersions] = useState([]);
  useEffect(() => {
    setLocalDrug({ ...drug });
  }, []);

  const setValue = (key, value) => {
    setLocalDrug({ ...localDrug, [key]: value });
  };

  const setDataValue = (key, value) => {
    let data = { ...localDrug.data };
    data[key] = value;
    setLocalDrug({ ...localDrug, data });
  };

  const canSave = !(localDrug.name && localDrug.data?.expiry_buffer_days);
  return (
    <div>
      <div className={styles.profile_row}>
        <div>
          <div className={styles.section_title}>Name</div>
          <TextField
            label=""
            placeholder=""
            value={localDrug?.name}
            onChange={(e) => {
              setValue("name", e.target.value);
              setError("");
            }}
            autoComplete="off"
            sx={{
              "& .MuiInputBase-input": {
                padding: "6px",
                width: "300px",
              },
            }}
          />
        </div>
      </div>
      <div className={styles.profile_row}>
        <div>
          <div className={styles.section_title}>Expiry Lead Time (days)</div>
          <TextField
            label=""
            placeholder=""
            value={localDrug.data?.expiry_buffer_days}
            onChange={(e) => {
              setDataValue("expiry_buffer_days", e.target.value);
              setError("");
            }}
            autoComplete="off"
            sx={{
              "& .MuiInputBase-input": {
                padding: "6px",
                width: "300px",
              },
            }}
          />
        </div>
      </div>

      <LoadingButton
        variant="contained"
        loading={isSaving}
        onClick={() => {
          setIsSaving(true);
          if (!newSite) {
            put(`/drug_admin/${localDrug.id}`, { ...localDrug, study_id })
              .then(() => {
                setSite(localDrug);
                setIsSaving(false);
                setEdit(false);
              })
              .catch((err) => {
                setError("Cannot re-use site name or code that already exists.");
                setIsSaving(false);
              });
          } else {
            post("/drug_admin", { ...localDrug, study_id })
              .then(() => {
                router.navigate("/admin/drug");
              })
              .catch((err) => {
                setError("Cannot re-use site name or code that already exists.");
                setIsSaving(false);
              });
          }
        }}
        disabled={canSave}
      >
        SAVE
      </LoadingButton>
      <LoadingButton
        variant="contained"
        color="inherit"
        sx={{ color: "#555" }}
        loading={false}
        onClick={() => {
          if (!newSite) {
            setEdit(false);
          } else {
            router.navigate("/admin/drug");
          }
        }}
        style={{ marginLeft: 20 }}
      >
        CANCEL
      </LoadingButton>
      <div className={styles.error}> {error}</div>
    </div>
  );
};

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      className={styles.tab_panel}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

export default function SiteDetails(props) {
  const { add, studyConfig } = props;
  const study_id = useSelector((state) => state.study.active_study_id);
  const [isEdit, setEdit] = useState(add || false);
  const [regionList, setRegionList] = useState([]);
  const location = useLocation();
  const [drug, setDrug] = useState({
    email: "",
    first_name: "",
    last_name: "",
    time_zone: "",
    phone: "",
  });

  //   useEffect(() => {
  //     get("/regions").then((ret) => {
  //       const { data } = ret;
  //       setRegionList(data);
  //     });
  //   }, []);

  useEffect(() => {
    const id = location && location.pathname && location.pathname.split("/").slice(-1);
    //the above has some funkiness with the url routing, so check if it's an int before requesting the following
    if (id && parseInt(id)) {
      get(`/drug_admin/${id}`).then((ret) => setDrug(ret.data?.data));
    }
  }, [location]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.heading1}>{add ? "Add Drug" : `Drug: ${drug.name}`}</div>
      {isEdit ? (
        <EditForm
          drug={drug}
          setEdit={setEdit}
          setSite={setDrug}
          regionList={regionList}
          newSite={add}
          study_id={study_id}
          studyConfig={studyConfig}
        />
      ) : (
        <Form drug={drug} setEdit={setEdit} regionList={regionList} study_id={study_id} studyConfig={studyConfig} />
      )}
    </div>
  );
}
